// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R
import React from 'react';
import styles from './index.module.scss';
import { mergeClasses } from 'util/commons';

interface Props {
  id?: string;
  className?: string;
  checked: boolean;
  onChange?: (e: React.ChangeEvent) => void;
  type?: 'dark' | 'green' | 'default';
}

export const CustomCheckBoxV2 = ({
  id,
  checked,
  onChange,
  type,
}: React.PropsWithChildren<Props>) => {
  return (
    <div
      className={mergeClasses(styles.customCheckBox, {
        [styles.dark]: type === 'dark',
        [styles.green]: type === 'green',
      })}
    >
      <input id={id} checked={checked} onChange={onChange} type="checkbox" />
      <label htmlFor={id}></label>
    </div>
  );
};
